import React, { Component } from "react";
import PaymentResultPage from "./PaymentResultPage";

const V034_HELP_TEXT = [
  "Kartın belli bir tutarın üstünde online işlemlere izni olmayabilir.",
  "Kartın o gün içinde belli sayıda online işlem adedine izni olabilir ve bu sayı aşılmış olabilir.",
  "Eğer bir ön otorizasyon işlemi ise, kartın ön otorizasyon yetkisi olmayabilir.",
  "Eğer saklı kart ile yapılan bir işlem ise, kartın cvv'siz işlem yetkisi olmayabilir.",
  "Karta özel Directory server tarafında Areq mesajı oluşmamış olabilir.",
];

export class PaymentFailed extends Component {
  state = {
    shouldAnimateCard: false,
  };

  componentDidMount() {
    const badge = document.querySelector(".grecaptcha-badge");
    if (badge instanceof HTMLElement) {
      badge.style.display = "none";
    }

    this.handleBackButton = (event) => {
      event.preventDefault();
      window.history.pushState(null, null, window.location.href);
    };

    window.addEventListener("popstate", this.handleBackButton);
    window.history.pushState(null, null, window.location.href);

    this.setState({ shouldAnimateCard: true });
    window.setTimeout(() => this.setState({ shouldAnimateCard: false }), 900);
  }

  componentWillUnmount() {
    window.removeEventListener("popstate", this.handleBackButton);
  }

  getErrorDetails = () => {
    const params = new URLSearchParams(window.location.search);
    return {
      errorCode: params.get("code") || "",
      errorMessage: params.get("message") || "",
    };
  };

  renderErrorDetails = (errorCode, errorMessage) => {
    if (!errorCode && !errorMessage) {
      return null;
    }

    return (
      <div className="t-paymentResult-errorDetail">
        {errorCode ? <span className="t-paymentResult-errorCode">{errorCode}</span> : null}
        {errorCode && errorMessage ? (
          <span className="t-paymentResult-errorSep" aria-hidden="true">
            |
          </span>
        ) : null}
        {errorMessage ? (
          <span className="t-paymentResult-errorMessage">{errorMessage}</span>
        ) : null}
      </div>
    );
  };

  renderV034Help = () => (
    <div className="t-eminPayOrder-warningAlert t-paymentResult-helpAlert">
      <div className="t-eminPayOrder-warningAlert-icon" aria-hidden="true">
        <i className="t-icon-warning" />
      </div>
      <div className="t-eminPayOrder-warningAlert-content">
        <strong className="t-eminPayOrder-warningAlert-title">Olası nedenler</strong>
        {V034_HELP_TEXT.map((line) => (
          <p key={line}>{line}</p>
        ))}
      </div>
    </div>
  );

  render() {
    const { errorCode, errorMessage } = this.getErrorDetails();

    return (
      <PaymentResultPage
        pageTitle="Ödeme Talimatı"
        pageSubtitle="Talimat işlemi sırasında bir hata oluştu."
        themeClass="t-memberDetail-header--orange"
        iconClass="t-icon-error_outline"
        title="Talep Alınırken Hata Oluştu"
        message="İşleminiz tamamlanamadı. Hata detaylarını inceleyerek tekrar deneyebilirsiniz."
        shouldAnimateCard={this.state.shouldAnimateCard}
        primaryAction={{
          to: "/Home/CreatePayment",
          label: "Tekrar Dene",
        }}
        secondaryAction={{
          to: "/Home/ListPayments",
          label: "Talimatlarıma Git",
          icon: "t-icon-list",
        }}
      >
        {this.renderErrorDetails(errorCode, errorMessage)}
        {errorCode === "V034" ? this.renderV034Help() : null}
      </PaymentResultPage>
    );
  }
}

export default PaymentFailed;
